module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_c('div', {
    staticClass: "bg_box"
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('van-swipe', {
    attrs: {
      "autoplay": 3000,
      "show-indicators": false
    }
  }, _vm._l((_vm.bannerData), function(item, index) {
    return _c('van-swipe-item', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_c('van-image', {
      attrs: {
        "width": "100%",
        "height": "100%",
        "fit": "cover",
        "lazy-load": "",
        "src": item.image
      },
      scopedSlots: _vm._u([{
        key: "error",
        fn: function() {
          return [_vm._v("加载失败")]
        },
        proxy: true
      }], null, true)
    })], 1)])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "index_box"
  }, [_c('div', {
    staticClass: "index_type_box"
  }, [_c('van-grid', {
    attrs: {
      "border": false,
      "column-num": 5
    }
  }, _vm._l((_vm.typeData), function(item, index) {
    return _c('van-grid-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.gotolink(item.id)
        }
      }
    }, [_c('van-image', {
      attrs: {
        "src": item.url
      }
    }), _vm._v("\n          " + _vm._s(item.name) + "\n        ")], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "index_tips_box"
  }, [_c('van-notice-bar', {
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "color": "#1989fa",
      "background": "#ecf9ff",
      "left-icon": "info-o",
      "text": "注意：考试历仅提示你所关注的考试，且该考试的报名、考试或查询日期是在当期日期开始半年内的。提示以红色圆点表示，所有关注的考试可在“我的关注”里看到。"
    }
  })], 1), _vm._v(" "), _c('div', [_c('Calendar', {
    ref: "Calendar",
    attrs: {
      "events": _vm.defaultDate
    },
    on: {
      "select": _vm.selectDay,
      "monthChanged": _vm.monthChanged
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 0
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index_ba"
  }, [_c('a', {
    attrs: {
      "href": "https://www.beian.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备2020036951号-1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7e72a1ac"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = 701
// module chunks = 1